import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import LogoSection from 'layout/MainLayout/LogoSection';
import { useState, cloneElement } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import LoginModal from 'views/pages/authentication/authentication3/LoginModal';
import { useScrollTrigger } from '@mui/material';

const drawerWidth = 240;
const navItems = [
  {
    label: 'Inicio',
    link: 'home',
    type: 'text'
  },
  {
    label: 'Estructura',
    link: 'structure-alianza',
    type: 'text'
  },
  {
    label: 'Ley',
    link: 'law-public',
    type: 'text'
  },
  {
    label: 'Lineamiento',
    link: 'guidelines-public',
    type: 'text'
  }
  // {
  //   label: 'Contacto',
  //   link: 'contact',
  //   type: 'text'
  // }
];

const navItemsLoginRegister = [
  {
    label: 'Registro',
    link: 'register',
    type: 'text'
  }
  // {
  //   label: 'Iniciar Sesión',
  //   link: 'login',
  //   type: 'contained'
  // }
];

const ElevationScroll = (props) => {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined
  });

  return cloneElement(children, {
    elevation: trigger ? 4 : 0
  });
};

const MinimalLayout = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box component="span" sx={{ display: 'block', flexGrow: 1 }}>
        <LogoSection />
      </Box>
      <Divider />
      <List>
        {[...navItems, ...navItemsLoginRegister].map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              selected={location.pathname === `/${item.link.toLowerCase()}`}
              component={Link}
              to={item.link}
              sx={{ textAlign: 'center' }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
        <ListItem disablePadding>
          <ListItemButton selected={location.pathname === `/login`} component={Link} to={'login'} sx={{ textAlign: 'center' }}>
            <ListItemText primary={'Iniciar Sesión'} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar component="nav" sx={{ backgroundColor: '#36517C', maxHeight: '90px' }}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' }, color: '#2196F3' }}
            >
              <MenuIcon />
            </IconButton>
            <Box component="span" sx={{ display: 'block', flexGrow: 1 }}>
              <LogoSection isMinimal={true} />
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'block', flexGrow: 1 } }}>
              {navItems.map((item, index) => (
                <Link to={item.link} key={index} style={{ textDecoration: 'none' }}>
                  <Button
                    variant={item.type}
                    sx={{
                      marginRight: 5,
                      color: '#FFF',
                      borderBottom: `4px solid ${location.pathname === `/${item.link.toLowerCase()}` ? '#2196F3' : 'transparent'}`
                    }}
                  >
                    {item.label}
                  </Button>
                </Link>
              ))}
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Link to={'register'} style={{ textDecoration: 'none' }}>
                <Button
                  color={location.pathname === `/register` ? 'primary' : 'inherit'}
                  variant={location.pathname === `/register` ? 'contained' : 'outlined'}
                  sx={{
                    marginRight: 2,
                    borderRadius: 20,
                    color: '#FFF'
                  }}
                >
                  {'Registro'}
                </Button>
              </Link>
              <Button
                onClick={() => setOpenLogin(true)}
                variant={'contained'}
                sx={{
                  marginRight: 2,
                  borderRadius: 20,
                  color: '#FFF'
                }}
              >
                {'Iniciar Sesión'}
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box component="main" sx={{ width: '100%' }}>
        <Toolbar />
        <Outlet />
      </Box>
      <LoginModal open={openLogin} setOpen={setOpenLogin} />
    </Box>
  );
};

MinimalLayout.propTypes = {
  window: PropTypes.func
};

ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  window: PropTypes.func
};
export default MinimalLayout;
